import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationService } from '../../../common/services/Communication.service';
import { environment } from '../../../../environments/environment';
import { dataModel, ExampleSummit, Industry, PremiumIndustry } from '../../../models/data.model';

// tslint:disable: no-string-literal

@Component({
  selector: 'app-account-case',
  templateUrl: './account-case.component.html',
  styleUrls: ['./account-case.component.sass'],
  encapsulation: ViewEncapsulation.None
})

export class AccountCaseComponent implements OnInit  {
  data: dataModel;
  example: ExampleSummit;
  currentIndustryRoute: any;
  id: any;
  assets: string;
  path: any;
  imgThumb: any;
  castStudyData = new Industry(name, this.router, this.data, this.id);
  viewStudyData: PremiumIndustry;

  constructor(
    private route: ActivatedRoute,
    communicationService: CommunicationService,
    private router: Router) {
    this.assets = environment.assetsURL;
    this.data = communicationService.data;
    this.route.url.subscribe(el => { this.currentIndustryRoute = el[0].path; } );
    this.path = this.router.url.replace(`/industries/${this.currentIndustryRoute}/`, '');
   }

  ngOnInit() {

    for (const industries of this.data.PremiumIndustries) {
      if (industries.router === this.currentIndustryRoute) {
        industries['data'].forEach(element => {
          if ( element.router === this.path ) {
            this.viewStudyData = element;
          }
       });
      }
    }
  }
}
